//components
import { CountUp } from '../CountUp';

//styles
import {
  Wrap,
  ScaleLabel,
  ScaleRow,
  Stat,
  StatValue,
  StatUnit,
  StatLabel,
} from './PlatformScale.styles';

export const platformScaleStats = [
  { value: 1800, label: 'global customers' },
  { value: 4500, label: 'warehouses on the network' },
  { value: 230000, label: 'vetted carriers' },
  { value: 14, unit: 'M+', label: 'dock appointments a year' },
];

export function PlatformScale({
  stats,
  label = 'Platform scale · today',
  locale,
}) {
  return (
    <Wrap>
      <ScaleLabel>{label}</ScaleLabel>
      <ScaleRow>
        {stats.map((stat) => (
          <Stat key={stat.label}>
            <StatValue>
              {stat.prefix}
              <CountUp value={stat.value} locale={locale} />
              {stat.unit && (
                <StatUnit $word={stat.unit.trim().length > 2}>
                  {stat.unit}
                </StatUnit>
              )}
            </StatValue>
            <StatLabel>{stat.label}</StatLabel>
          </Stat>
        ))}
      </ScaleRow>
    </Wrap>
  );
}
